import { Spinner } from '@chakra-ui/react'
import React, { Suspense } from 'react'

/**
 * Dynamically loaded Monaco Editor. Only downloads Monaco when this component
 * is rendered, so it can be used without pulling the editor into the main bundle.
 */
const MonacoEditorLazy = React.lazy(() =>
  import('@monaco-editor/react').then(m => ({ default: m.Editor })),
)

export interface CodeEditorProps {
  value: string
  onChange?: (value: string) => void
  height?: string | number
  readOnly?: boolean
  language?: string
  placeholder?: string
  'data-testid'?: string
}

const defaultLoading = (
  <Spinner size="sm" color="presets.neutral.50" thickness="2px" />
)

export const CodeEditor = ({
  value,
  onChange,
  height = '300px',
  readOnly = false,
  language = 'json',
  'data-testid': dataTestId,
}: CodeEditorProps) => {
  return (
    <Suspense fallback={defaultLoading}>
      <MonacoEditorLazy
        height={height}
        language={language}
        value={value}
        onChange={
          onChange ? (v: string | undefined) => onChange(v ?? '') : undefined
        }
        loading={defaultLoading}
        options={{
          readOnly,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          wordWrap: 'on',
          lineNumbers: 'on',
          folding: true,
        }}
        wrapperProps={dataTestId ? { 'data-testid': dataTestId } : undefined}
      />
    </Suspense>
  )
}
